import * as React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
// import { getURL, getToken } from '../utils/index';
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Link from "@mui/material/Link";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { mainListItems, secondaryListItems } from "./adminlistItems";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import jwt_decode from "jwt-decode";

const logoutHandler = () => {
  localStorage.setItem("token", "");
  window.location = "/";
};

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));

const mdTheme = createTheme();

function CreateUserPage() {
  const theme = createTheme();

  const [open, setOpen] = React.useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  const [userData, setUserData] = useState({});
  const logoutHandler = () => {
    localStorage.setItem("token", "");
    window.location = "/";
  };

  const [role, setrole] = useState("");
  const handleChange = (event) => {
    setrole(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
  };

  const [allroles, setallroles] = useState();
  const [fname, setfname] = useState("");
  const [lname, setlname] = useState("");
  const [uname, setuname] = useState("");
  const [email, setmail] = useState("");
  // const [roleId, setroleId] = useState("");

  const addUser = (e) => {
    e.preventDefault();
    axios
      .post(
        "https://asia-south1-reqapproval-407cf.cloudfunctions.net/api/users",
        {
          username: uname,
          email,
          fname,
          lname,
          roleId: parseInt(role),
        }
      )
      .then((res) => {
          alert('User added successfully!')
          window.location = '/admin/users'
      })
      .catch((e) => {
        if(e.response.status === 409)
        {
            alert('Username already exists!')
        }
        else
        {
            alert('Server Error')
        }
      });
  };

  const getallroles = async()=>{
            try{
                const roles = await axios.get('https://asia-south1-reqapproval-407cf.cloudfunctions.net/api/roles');
                setallroles(roles.data);
                console.log(allroles);
            }
            catch(err){console.log(err)};
        }
    
        useEffect(()=>{
            getallroles();
        },[]);

  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar position="absolute" open={open}>
          <Toolbar
            sx={{
              pr: "24px", // keep right padding when drawer closed
            }}
          >
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              sx={{
                marginRight: "36px",
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1 }}
            >
              Dashboard
            </Typography>
            <p onClick={logoutHandler} style={{ cursor: "pointer" }}>
              Logout
            </p>
          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open}>
          <Toolbar
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              px: [1],
            }}
          >
            <IconButton onClick={toggleDrawer}>
              <ChevronLeftIcon />
            </IconButton>
          </Toolbar>
          <Divider />
          <List component="nav">
            {mainListItems}
            <Divider sx={{ my: 1 }} />
            {secondaryListItems}
          </List>
        </Drawer>
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          <Toolbar />
          <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <ThemeProvider theme={theme}>
                  <Container component="main" maxWidth="xs">
                    <CssBaseline />
                    <Box
                      sx={{
                        marginTop: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
                        <LockOutlinedIcon />
                      </Avatar>
                      <Typography component="h1" variant="h5">
                        Create User
                      </Typography>
                      <Box
                        component="form"
                        noValidate
                        onSubmit={handleSubmit}
                        sx={{ mt: 3 }}
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <TextField
                              required
                              fullWidth
                              id="username"
                              label="Username"
                              name="username"
                              autoComplete="username"
                              onChange={(e)=>{
                                  setuname(e.target.value);
                              }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              required
                              fullWidth
                              name="email"
                              label="email"
                              type="email"
                              id="email"
                              autoComplete="email"
                              onChange={(e)=>{
                                setmail(e.target.value);
                            }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              required
                              fullWidth
                              name="fname"
                              label="fname"
                              type="fname"
                              id="fname"
                              autoComplete="fname"
                              onChange={(e)=>{
                                setfname(e.target.value);
                            }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              required
                              fullWidth
                              name="lname"
                              label="lname"
                              type="lname"
                              id="lname"
                              autoComplete="lname"
                              onChange={(e)=>{
                                setlname(e.target.value);
                            }}
                            />
                            <Grid style={{ marginTop: "10px" }} item xs={12}>
                              <FormControl fullWidth>
                                <InputLabel>Role</InputLabel>
                                <Select
                                  id="role"
                                  name="role"
                                  value={role}
                                  label="Role"
                                  onChange={handleChange}
                                >
                                  {
                                    allroles?.map((role,index)=>(
                                      <MenuItem value={`${role.id}`}>{role.name}</MenuItem>
                                    ))
                                  }
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Button
                          type="submit"
                          fullWidth
                          variant="contained"
                          sx={{ mt: 3, mb: 2 }}
                          onClick={addUser}
                        >
                          Create User
                        </Button>
                      </Box>
                    </Box>
                  </Container>
                </ThemeProvider>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default function AdminDashboardPage() {
  return <CreateUserPage />;
}
